export const availableLanguages: Readonly<string[]> = ['en-US', 'sl-SI'];
